import { Injectable, signal, computed, WritableSignal, Signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScreenSpinnerService {
  private _activeSpinners: WritableSignal<Map<string, boolean>> = signal<Map<string, boolean>>(
    new Map<string, boolean>()
  );

  show(id: string): void {
    this._activeSpinners.update((spinners: Map<string, boolean>) => {
      const newSpinners = new Map(spinners);
      newSpinners.set(id, true);
      return newSpinners;
    });
  }

  hide(id: string): void {
    this._activeSpinners.update((spinners: Map<string, boolean>) => {
      const newSpinners = new Map(spinners);
      newSpinners.set(id, false);
      return newSpinners;
    });
  }

  hideAll(): void {
    this._activeSpinners.update((spinners: Map<string, boolean>) => {
      const newSpinners = new Map(spinners);
      newSpinners.forEach((_value, key) => {
        newSpinners.set(key, false);
      });
      return newSpinners;
    });
  }

  isVisible(id: string): Signal<boolean> {
    return computed(() => {
      const visible = !!this._activeSpinners().get(id);
      return visible;
    });
  }
}
